import styles from './NoDataFound.module.scss';
import noDataImage from '../../../assets/images/NotFound.svg';


type Props = {
    title: string;
    subTitle?: string | React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    imgStyle?: React.CSSProperties;
    img?: any
}

const NoDataFound = ({ title, subTitle, style = {}, className, imgStyle, img = null }: Props) => {
    return (
        <div className={className}>
            <div style={style} className={`${styles.noDataContainer}`}>
                <div style={imgStyle} className={styles.imgContainer}>
                    <img src={img ? img : noDataImage} alt="not-found" />
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.title}>
                        {title}
                    </div>
                    <div className={styles.subTitle}>
                        {subTitle}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NoDataFound;